<template>

  
  
	<div v-if="myroleId==3" class="productc--price-info-wrapper">
	  <div class="d-flex justify-content-left" >
		
		<div class="discount-wrapper">
		  <span class="discount-txt">Commission : {{product.commission?product.commission:'0'}}% </span>
		</div>
	  </div>
	 
	</div>
  

  
</template>

<script>
export default {
  name: "ProductPrice",
  props: {
    category:Boolean,
    details:Boolean,
    relative:Boolean,
    product:Object,
	myroleId:{type:String},
  },
  data(){
    return {
      product_qty:1,
      special_price:100,
      price:200
    }
  }
};
</script>
<style scoped lang="scss">
$whiteColor: #ffffff;
$blackColor: #000000;
$themeColor2: #8507d6;
$themeColor3: #b24bf1;
$redColor: #e61583;

.productc {
  &--price-info-wrapper {
    /*margin: 20px 0;*/
    width: 100%;

    .actual-price-wrapper {
      padding-right: 10px;
      border-right: 1px solid #eeeeee;

      .old-price {
        color: #93949b;
        text-decoration: line-through;
		font-size:13px;
      }

      .actual-price {
        color: #000000;
        font-weight: bold;
      }
    }

    .discount-wrapper {
      padding-left: 10px;

      .discount-txt {
        color: #ec3f79;
        font-weight: bold;
		font-size: 14px;
      }
    }
  }
}


.product-details {
  &--price-info {
    width: 100%;

    .product-actual-price {
      font-size: 25px;
    }
	.mrpactual-price{
	 font-size: 23px;
	}

    .product-old-price {
      text-decoration: line-through;
    }

    .product-discount-percentage {
      color: $themeColor2;
	  border-left: 1px solid #c6c6c6;
		margin: 0 10px;
		padding-left: 5px
    }

    .product-old-price,
    .product-discount-percentage {
      font-size: 24px;
	  
    }
  }
}

.related-products {
  &--wrapper {
    margin-top: 100px;
    background: #f9f9f9;
    padding: 50px 0 40px;

    .related-product {
      &--price-info-wrapper {
        margin-bottom: 24px;

        .actual-price-wrapper {
          padding-right: 10px;
          border-right: 1px solid #eeeeee;

          .old-price {
            color: #93949b;
            text-decoration: line-through;
			font-size:13px;
          }

          .actual-price {
            color: $blackColor;
            font-weight: bold;
          }
        }
      }

      &--discount-wrapper {
        padding-left: 10px;

        .discount-txt {
          color: $redColor;
          font-weight: bold;
		  font-size: 14px;
        }
      }
    }
  }

  &--txt {
    font-size: 48px;
    color: $blackColor;
    margin-bottom: 60px;
  }
}
</style>